'use client';

import { ToolsTranslations } from '@/lib/translations/types';
import CurrencySelector from '@/components/utils/CurrencySelector';

interface ResultsDisplayProps {
  finalAmount: number;
  totalReturn: number;
  translations: ToolsTranslations['savings'];
  currency: string;
  onCurrencyChange: (currency: string) => void;
}

export default function ResultsDisplay({ finalAmount, totalReturn, translations, currency, onCurrencyChange }: ResultsDisplayProps) {
  // Get locale based on currency
  const getLocale = (currency: string) => {
    switch (currency) {
      case '£': return 'en-GB';
      case '$': return 'en-US';
      case '€': return 'de-DE';
      case 'CHF': return 'de-CH';
      case 'kr': 
        // For 'kr' we need to determine if it's SEK, NOK, or DKK based on context
        // Since we can't distinguish between them by symbol alone, default to Swedish
        return 'sv-SE';
      default: return 'sv-SE';
    }
  };

  const locale = getLocale(currency);

  return (
    <div className="text-center mb-8">
      <div className="text-sm text-gray-600 mb-2">
        <b>{translations.resultTitle}</b>
      </div>
      <div className="text-4xl lg:text-5xl font-bold text-gray-800 mb-2">
        {Math.round(finalAmount).toLocaleString(locale)} {currency}
      </div>
      <div className="text-lg text-gray-600">
        {translations.resultReturnPrefix} {Math.round(totalReturn).toLocaleString(locale)} {currency} {translations.resultReturnSuffix}
      </div>
      
      {/* Currency Selector */}
      <div className="flex justify-center mt-6">
        <div className="w-64">
          <CurrencySelector
            value={currency}
            onChange={onCurrencyChange}
            localStorageKey="currency"
          />
        </div>
      </div>
    </div>
  );
}
